import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { ConsentService } from '@spartacus/core';
import { CmsComponentData, MediaContainer } from '@spartacus/storefront';
import { YouTubeVideoService } from '../../../services/youtube-video.service';
import { InteractiveCarouselComponent } from '../../interactive-carousel/interactive-carousel.component';

export interface GgMainIntroSliderVideoItemData {
  uid: string;
  image?: MediaContainer;
  mobileImage?: MediaContainer;
  styleClasses?: string;
  cssColorClass?: string;
  videoLink?: string;
}

@Component({
  selector: 'app-gg-main-intro-slider-video-item',
  templateUrl: 'gg-main-intro-slider-video-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GgMainIntroSliderVideoItemComponent {
  // Inputs
  mainIntroCarousel = input<InteractiveCarouselComponent>();

  // Services
  private componentData = inject(CmsComponentData<GgMainIntroSliderVideoItemData>);
  private consentService = inject(ConsentService);
  private destroyRef = inject(DestroyRef);
  protected youtubeService = inject(YouTubeVideoService);

  // Signals
  data = toSignal(this.componentData.data$);
  consent = toSignal(this.consentService.checkConsentGivenByTemplateId('FUNCTIONAL'));
  toggledVideo = signal(false);

  constructor() {
    // Effect to handle carousel slide changes
    effect(() => {
      const carousel = this.mainIntroCarousel();
      if (carousel) {
        carousel.slideChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
          if (this.toggledVideo()) {
            this.toggledVideo.set(false);
          }
        });
      }
    });
  }

  toggleVideo(state: boolean): void {
    this.toggledVideo.set(state);
  }
}
